export default __webpack_public_path__ + "static/media/foxblob.2d45c602.gif";